<template>
  <v-dialog
      v-model="dialog"
      max-width="100vh"
      @keydown.esc="cancel()"
      @click:outside="cancel()"
  >
    <v-card>
      <v-toolbar color="primary" dark dense flat>
        <v-toolbar-title class="white--text">{{ $t('FORGOT_PASSWORD') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text
          class="secondary--text pa-4 pb-8 font-weight-bold"
      >
        <v-form ref="forgot">
          <v-radio-group ref="chooseNationality" v-model="cardType" height="10" row
                         @change="reset(false);getNationalities()">
            <v-radio
                :label="$t('NID')"
                :value="1"
                color="primary"
            ></v-radio>
            <v-radio
                :label="$t('PASSPORT')"
                :value="2"
                color="primary"
            ></v-radio>
          </v-radio-group>
          <v-text-field
              v-if="cardType === 1"
              :placeholder="$t('UserData.NATIONALITY')"
              :value="serverTranslate('مصر|Egypt')"
              append-icon="mdi-earth"
              color="primary"
              dense
              disabled
              outlined
              required
          ></v-text-field>
          <v-autocomplete
              v-show="cardType === 2"
              ref="nationality"
              v-model="nationality"
              :items="serverTranslateArray(nationalities, 'name')"
              :label="$t('UserData.NATIONALITY')"
              :rules="nationalityRules"
              append-icon="mdi-earth"
              dense
              item-text="name"
              item-value="id"
              name="nationality"
              outlined
              required
              validate-on-blur
          ></v-autocomplete>
          <v-text-field
              ref="nID"
              v-model="cardID"
              :counter="cardType === 1 ? 14 : 25"
              :label="cardType === 1 ? $t('NID') : $t('PASSPORT')"
              :maxlength="cardType === 1 ? 14 : 25"
              append-icon="mdi-card-account-details-outline"
              color="primary"
              dense
              outlined
              required
              @keydown.space="preventLeadingSpace"
          ></v-text-field>
          <v-text-field
              ref="email"
              v-model="email"
              :label="$t('EMAIL')"
              :rules="emailRules"
              append-icon="mdi-at"
              color="primary"
              dense
              outlined
              required
              @keydown.space="preventLeadingSpace"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="sendNewPassword">{{ $t("SEND_NEW_PASSWORD") }}</v-btn>
        <v-btn color="error" @click.native="cancel()">{{ $t("CANCEL") }}</v-btn>
      </v-card-actions>
    </v-card>
    <ad-confirmDialogCancel ref="confirmCancel"></ad-confirmDialogCancel>
  </v-dialog>
</template>
<script>
import generalFunctions from "@/mixins/generalFunctions";
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import Swal from "sweetalert2";

export default {
  name: "ad-confirmDialog",
  mixins: [serverTranslationsMixin, generalFunctions],
  components: {
    "ad-confirmDialogCancel": ConfirmDialog
  },
  mounted() {
    this.getNationalities()
  },
  computed: {
    universityHRID() {
      return localStorage.getItem("universityHRID");
    }
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      cardType: 1,
      cardID: "",
      email: "",
      nationality: {},
      nationalities: [],
      nationalityRules: [
        this.$store.state.rules.required,
      ],
      NIDRulse: this.$store.state.rules.NIDRulse,
      passportRulse: this.$store.state.rules.passportRulse,
      emailRules: this.$store.state.rules.emailRules
    }
  },
  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    getNationalities() {
      const hasEgypt = 0
      const data = {"hasEgypt": hasEgypt}
      this.$http.post("/api/regions_data/get_countries/", data)
          .then(
              res => {
                if (res) {
                  this.nationalities = res.data.data
                }
              }
              , err => {
                this.$toasted.show(
                    this.serverTranslate(err.response.data.message),
                    {
                      type: "error",
                      icon: "error_outline",
                      theme: "bubble",
                      position: "bottom-left",
                      duration: 3000
                    }
                );
              }
          )
    },
    sendNewPassword() {
      const data = {
        cardType: this.cardType,
        cardID: this.cardID,
        email: this.email,
        nationality: this.nationality,
      }
      if (this.$refs.forgot.validate()) {
        this.$http.post("/api/users/forget_password/", data)
            .then(
                res => {
                  this.dialog = false
                  const newPass = res.data.data
                  if (this.universityHRID !== '1605.') {
                    Swal.fire({
                      title: 'تم تغيير كلمة المرور',
                      text: 'يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة ' + newPass,
                      icon: 'success',
                      confirmButtonText: 'موافق',
                      showCancelButton: false
                    }).then(() => {
                      this.dialog = false;
                      this.reset(true);
                    });
                  } else {
                    this.$toasted.show(this.$t("SUCCESS"), {
                      type: "success",
                      icon: "check_circle_outline",
                      duration: 3000,
                      theme: "bubble",
                      position: "bottom-left"
                    });
                    this.reset(true)
                  }


                },
                err => {
                  this.$toasted.show(
                      this.serverTranslate(err.response.data.message),
                      {
                        type: "error",
                        icon: "error_outline",
                        theme: "bubble",
                        position: "bottom-left",
                        duration: 3000
                      }
                  );
                }
            )
      }
    },
    reset(changeRadio) {
      this.$refs.nationality.reset()
      this.$refs.nID.reset()
      this.$refs.email.reset()
      this.cardID = ""
      this.email = ""
      this.nationality = {}
      if (changeRadio) {
        this.cardType = 1
      }
    },
    cancel() {
      this.$refs.confirmCancel
          .open("CONFIRMATION_MESSAGE", "CONFIRM_CANCEL")
          .then(confirm => {
            if (confirm) {
              this.dialog = false
              this.reset(true)
            }
          })
    }
  }
}
</script>
